import { jsx } from 'react/jsx-runtime';

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const CloseIcon = (_a) => {
    var htmlProperties = __rest(_a, []);
    return (jsx("svg", Object.assign({}, htmlProperties, { xmlns: "http://www.w3.org/2000/svg", width: "13.426", height: "13.423", viewBox: "0 0 13.426 13.423" }, { children: jsx("path", { id: "Icon_ionic-ios-close", "data-name": "Icon ionic-ios-close", d: "M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z", transform: "translate(-11.285 -11.289)", fill: "#707070" }) })));
};

const PenIcon = (_a) => {
    var htmlProperties = __rest(_a, []);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "17", height: "17", viewBox: "0 0 17 17" }, htmlProperties, { children: jsx("path", { id: "FA-pen", d: "M16.376,1.868,15.131.623a2.125,2.125,0,0,0-3.005,0l-11.7,11.7L0,16.115A.8.8,0,0,0,.794,17a.814.814,0,0,0,.089,0l3.79-.419,11.7-11.7a2.125,2.125,0,0,0,0-3ZM4.186,15.562,1.1,15.9l.344-3.094L10.2,4.048,12.951,6.8Zm11.44-11.44L13.7,6.045,10.954,3.3l1.923-1.923a1.063,1.063,0,0,1,1.5,0l1.245,1.245a1.064,1.064,0,0,1,0,1.5Z", transform: "translate(0.001)", fill: "#fafafa" }) })));
};

export { CloseIcon, PenIcon };
